import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Collapse, Container } from "reactstrap";
import logoSm from "../../assets/images/logo-sm.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";
import withRouter from "../../Components/Common/withRouter";
//i18n
import { withTranslation } from "react-i18next";

// Import Data
import navdata from "../LayoutMenuData";

//SimpleBar
import SimpleBar from "simplebar-react";
// import VerticalLayout from "../VerticalLayouts";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { changeSidebarVisibility } from "../../slices/thunks";
import "./style.scss";
import { GreyTimeLineIcon, TimeLineIcon } from "../../assets/images/svg/svg";
import { checkAccessPermission } from "../../Utils/CommonUtils";
// import { menuItems } from "../json/menu";

const SubChildItemLayout = ({ subItem }) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(window.location.pathname.includes(subItem.url));
  }, []);
  const menu = useSelector((state) => state.moduleaccesstree.menu);
  const checkAccess = (subItem) => {
    return true;
    // return menu.find(
    //   (item) =>
    //     item.code == subItem.code &&
    //     item.action == "VIEW" &&
    //     item.access_flag == 1
    // );
  };

  return (
    <>
      <>
        {checkAccess(subItem) && (
          <li className="nav-item">
            <Link
              className="nav-link"
              to="/#"
              data-bs-toggle="collapse"
              onClick={(e) => {
                e.preventDefault();
                setShow(!show);
              }}
            >
              {subItem.title}
            </Link>
            {show ? (
              <ul className="nav nav-sm flex-column">
                {subItem.menus &&
                  (subItem.menus || []).map(
                    (childItem, key) =>
                      checkAccess(childItem) && (
                        <li className="nav-item" key={key}>
                          <Link
                            to={childItem.url ? childItem.url : "/#"}
                            className={
                              window.location.pathname.includes(childItem.url)
                                ? "nav-link  text-primary"
                                : "nav-link"
                            }
                          >
                            {childItem.title}
                          </Link>
                        </li>
                      )
                  )}
              </ul>
            ) : null}
          </li>
        )}
      </>
    </>
  );
};

const SubChildLayout = ({ navData, show, setShow, index, selectedName }) => {
  const [showItems, setShowItems] = useState({});
  const menu = useSelector((state) => state.moduleaccesstree.menu);
  useEffect(() => {
    // setShow( window.location.pathname.includes(subItem.path))
  }, []);

  return (
    <>
      <SimpleBar id="navbar-nav" className="navbar-nav">
        <p className="title-t1">{navData[index]?.name}</p>
        <li className="nav-item">
          <ul className="nav nav-sm flex-column test">
            {navData[index]?.menus &&
              navData[index]?.menus.map((subItem, key) => {
                return (
                  <React.Fragment key={key}>
                    {checkAccessPermission("VIEW", subItem.code) &&
                    subItem.ui_visible &&
                    !subItem.menus ? (
                      <li className="nav-item">
                        <div className="d-flex flex-space-between nav-menu-item-container">
                          <span className="time-line">
                            {window.location.pathname.includes(subItem.url) ? (
                              <TimeLineIcon />
                            ) : (
                              <GreyTimeLineIcon />
                            )}
                          </span>
                          <Link
                            to={subItem.url ? subItem.url : "/#"}
                            className={
                              window.location.pathname.includes(subItem.url)
                                ? "nav-item-link"
                                : "nav-item-link-2"
                            }
                          >
                            {subItem.menu_name}
                          </Link>
                        </div>
                      </li>
                    ) : null}
                  </React.Fragment>
                );
              })}
          </ul>
        </li>
      </SimpleBar>
    </>
  );
};

const TwoColumnLayout = (props) => {
  const navData = navdata().props.children;
  const [show, setShow] = useState("");
  const [index, setIndex] = useState(0);
  const menuItems = useSelector((state) => state.sidebar);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  useEffect(() => {
    checkCurrentIndex();
    NavIndex();
  }, [menuItems]);
  const NavIndex = () => {
    let newMenu = menuItems;
    newMenu.map((item, ind) => {
      if (window.location.pathname.includes(item.url)) {
        setIndex(ind);
      }
    });
  };
  const checkCurrentIndex = () => {
    const ind = menuItems.map((item, index) => {
      if (
        item.url &&
        item.url.split("/")[1] == window.location.pathname.split("/")[1]
      ) {
        setIndex(index);
        return index;
      }
    });
  };
  const dispatch = useDispatch();
  const selectDashboardData = createSelector(
    (state) => state.Layout,
    (sidebarVisibilitytype) => sidebarVisibilitytype.sidebarVisibilitytype
  );
  const sidebarVisibilitytype = useSelector(selectDashboardData);
  const handle = (key, ind) => {
    if (show == key) {
      setShow("");
    } else {
      setShow(key);
    }
    setIndex(ind);
    var windowSize = document.documentElement.clientWidth;
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      const twoColumnMenu = document.querySelector(".twocolumn-iconview");
      if (document.body.classList.contains("twocolumn-panel")) {
        document.body.classList.remove("twocolumn-panel");
        twoColumnMenu.classList.remove("open");
        if (windowSize > 767)
          document.querySelector(".hamburger-icon").classList.toggle("open");
      }
    }
  };
  const menu = useSelector((state) => state.moduleaccesstree.menu);

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;
    // dispatch(changeSidebarVisibility("show"));

    if (windowSize > 767)
      document.querySelector(".hamburger-icon").classList.toggle("open");

    // Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      const twoColumnMenu = document.querySelector(".twocolumn-iconview");
      if (document.body.classList.contains("twocolumn-panel")) {
        document.body.classList.remove("twocolumn-panel");
        twoColumnMenu.classList.remove("open");
      } else {
        document.body.classList.add("twocolumn-panel");
        twoColumnMenu.classList.add("open");
      }
    }
  };

  return (
    <React.Fragment>
      <div id="scrollbar">
        <Container fluid>
          <div id="two-column-menu">
            <div className="twocolumn-iconview">
              <Link to="#" className="card--img--icon">
                <img
                  src={selectedUser.agsa_icon_media_url}
                  alt=""
                  // height="22"
                />
              </Link>
              <SimpleBar style={{ maxHeight: "calc(100vh - 110px)" }}>
                {(navData || []).map((item, currentIndex) => (
                  <React.Fragment>
                    {item.icon && checkAccessPermission("VIEW", item.code) ? (
                      item.menus ? (
                        <li
                          className={
                            // index == currentIndex ||
                            window.location.pathname.includes(item.url)
                              ? "nav-item-container"
                              : "nav-item-unselected-container"
                          }
                        >
                          <Link
                            onClick={() => handle(item.code, currentIndex)}
                            to={
                              item.menus.length > 0
                                ? item.menus[0].url
                                : item.url
                            }
                            subitems={item.id}
                            className="nav-icon"
                            data-bs-toggle="collapse"
                          >
                            <div className="d-flex flex-column justify-content-center  ">
                              <span>
                                {/* {currentIndex == index || */}
                                {window.location.pathname.includes(item.url)
                                  ? item?.fillIcon
                                  : item?.icon}
                              </span>
                              <span
                                className={
                                  // currentIndex == index ||
                                  window.location.pathname.includes(item.url)
                                    ? "nav-item-selected"
                                    : "nav-item-unselected"
                                }
                              >
                                {item?.name}
                              </span>
                            </div>
                          </Link>
                        </li>
                      ) : (
                        <>
                          <Link
                            onClick={() => handle(item.code, currentIndex)}
                            to={item.url ? item.url : "/#"}
                            subitems={item.code}
                            className="nav-icon"
                            data-bs-toggle="collapse"
                          >
                            {item.icon}
                          </Link>
                        </>
                      )
                    ) : null}
                  </React.Fragment>
                ))}

                <div className="navbar-brand-box horizontal-logo">
                  <Link to="/" className="logo logo-dark">
                    <span className="logo-sm">
                      <img src={logoSm} alt="" height="22" />
                    </span>
                    <span className="logo-lg">
                      <img src={logoDark} alt="" height="17" />
                    </span>
                  </Link>

                  <Link to="/" className="logo logo-light">
                    <span className="logo-sm">
                      <img src={logoSm} alt="" height="22" />
                    </span>
                    <span className="logo-lg">
                      <img src={logoLight} alt="" height="17" />
                    </span>
                  </Link>
                </div>
              </SimpleBar>
              <button
                onClick={toogleMenuBtn}
                type="button"
                className="btn btn-sm px-4 fs-16 header-item vertical-menu-btn topnav-hamburger position-absolute bottom-0"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
            </div>
          </div>
          <SubChildLayout
            navData={navData}
            show={show}
            setShow={setShow}
            index={index}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

TwoColumnLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(TwoColumnLayout));
